module.exports = __webpack_public_path__ + "img/deskalo_logo_definitivo_trasparente.fef9cfed.png";